var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('states'))+" ")]),_c('v-row',{staticClass:"mx-2"},[_vm._l((_vm.states),function(item,index){return [_c('ChannelOrderState',_vm._g({key:index,attrs:{"state-text":item.text,"state-key":item.key,"value":_vm.findOrderState(item.key)}},_vm.$listeners))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }